module.exports = __webpack_public_path__ + "static/media/GetADemo.de4a5347.svg";